export const environment = {
    production: true,
    env: 'stg',
    backendUrl: 'https://wow-stg.bnpparibas.com',
    samlApiUrl: 'https://wow-stg.bnpparibas.com/wow-apiproxy/',
    apiUrl: 'https://wow-stg.bnpparibas.com/wow-apiproxy/proxy/',
    apiRoot: 'api/',
    apiTokenParamName: 'bnppp',
    legalInfoUrl: 'https://securities.bnpparibas.com',
    logoutURL: 'https://ssologin-bp2s.staging.echonet/'
};
